import { useEffect, useState } from "react";
import { site, genericWhatsappLink } from "@/content/liane-site.ar";
import { WhatsAppIcon } from "./WhatsAppIcon";

export function StickyWhatsAppBar() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > window.innerHeight * 0.6);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className={`fixed inset-x-0 bottom-0 z-50 border-t border-l-border bg-l-background/95 px-4 pt-3 backdrop-blur-md transition-opacity duration-300 lg:hidden ${
        show ? "opacity-100" : "pointer-events-none opacity-0"
      }`}
      style={{ paddingBottom: "calc(0.75rem + env(safe-area-inset-bottom))" }}
    >
      <a
        href={genericWhatsappLink()}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex min-h-[3.25rem] w-full items-center justify-center gap-2 rounded-full bg-l-whatsapp text-base font-bold text-l-whatsapp-foreground"
      >
        <WhatsAppIcon className="size-5" />
        {site.whatsapp.stickyLabel}
      </a>
    </div>
  );
}

export function WhatsAppFab() {
  return (
    <a
      href={genericWhatsappLink()}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={site.whatsapp.fabAria}
      className="fixed bottom-6 start-6 z-50 hidden size-14 place-items-center rounded-full bg-l-whatsapp text-l-whatsapp-foreground shadow-l-lift transition-transform hover:scale-105 lg:grid"
    >
      <WhatsAppIcon className="size-7" />
    </a>
  );
}
